import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["photo", "prevButton", "nextButton"]
  static values = { total: Number }

  connect() {
    this.currentIndex = 0
    this.updateView()
    this.currentIndex = 0
    this.updateView()
    this.boundUpdateView = this.boundUpdateView || this.updateView.bind(this)
    window.addEventListener('resize', this.boundUpdateView)
  }

  disconnect() {
    if (this.boundUpdateView) {
      window.removeEventListener('resize', this.boundUpdateView)
    }
  }

  next() {
    const step = this.isMobile() ? 1 : 2
    if (this.currentIndex + step < this.totalValue) {
      this.currentIndex += step
      this.updateView()
    }
  }

  previous() {
    const step = this.isMobile() ? 1 : 2
    if (this.currentIndex - step >= 0) {
      this.currentIndex -= step
      this.updateView()
    } else {
      this.currentIndex = 0
      this.updateView()
    }
  }

  updateView() {
    const photosToShow = this.isMobile() ? 1 : 2

    this.photoTargets.forEach((photo, index) => {
      const photoIndex = parseInt(photo.dataset.index, 10)
      if (photoIndex >= this.currentIndex && photoIndex < this.currentIndex + photosToShow) {
        photo.classList.remove("hidden")
      } else {
        photo.classList.add("hidden")
      }
    })

    this.updateNavigation()
  }

  updateNavigation() {
    const photosToShow = this.isMobile() ? 1 : 2
    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = this.currentIndex === 0
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = this.currentIndex + photosToShow >= this.totalValue
    }
  }

  isMobile() {
    // Tailwind's `sm` breakpoint is 640px
    return window.innerWidth < 640
  }
  refresh() {
    this.connect()
  }
}